import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	close: {
		id: 'polaris-lib-right-sidebar.header.close',
		defaultMessage: 'Close',
		description: 'Tooltip content for the close button in the right sidebar header',
	},
});
